import { TopicParticipant } from 'susy-common/models';
import { IArchivedTopic, ITopic, ProjectModel } from '../../store/types';
import { ITopicDisplay } from './interfaces';

export const getProposedByParticipant = (
    project: ProjectModel
): TopicParticipant => {
    return {
        _id: project.proposedBy._id,
        firstName: project.proposedBy.firstName,
        lastName: project.proposedBy.lastName,
        profilePictureId: project.proposedBy.profilePictureId,
    };
};

export const getFirstSupervisorParticipant = (
    project: ProjectModel
): TopicParticipant => {
    return {
        _id: project.supervisor?._id,
        firstName: project.supervisor.firstName,
        lastName: project.supervisor.lastName,
        profilePictureId: project.supervisor.profilePictureId,
    };
};

export const getSecondSupervisorsParticipants = (
    project: ProjectModel
): Array<TopicParticipant> => {
    const secondSupervisorParticipants: Array<TopicParticipant> = [];
    for (
        let index = 0;
        index < project.secondSupervisorProposals.length;
        index++
    ) {
        const secondSupervisorProposals =
            project.secondSupervisorProposals[index];
        if (
            !secondSupervisorProposals ||
            !secondSupervisorProposals?.supervisorUser?._id
        ) {
            continue;
        }

        secondSupervisorParticipants.push({
            _id: secondSupervisorProposals.supervisorUser?._id,
            firstName: secondSupervisorProposals.supervisorUser.firstName,
            lastName: secondSupervisorProposals.supervisorUser.lastName,
            profilePictureId:
                secondSupervisorProposals.supervisorUser.profilePictureId,
        });
    }

    return secondSupervisorParticipants;
};
export const getTeamMembersParticipants = (
    project: ProjectModel
): Array<TopicParticipant> => {
    const teamMembersParticipants: Array<TopicParticipant> = [];
    if (project.teamList !== undefined) {
        for (
            let teamListIndex = 0;
            teamListIndex < project.teamList.length;
            teamListIndex++
        ) {
            const teamListMember = project.teamList[teamListIndex];
            teamMembersParticipants.push({
                _id: teamListMember.member._id,
                firstName: teamListMember.member.firstName,
                lastName: teamListMember.member.lastName,
                profilePictureId: teamListMember.member.profilePictureId,
            });
        }
    }

    return teamMembersParticipants;
};

export const getCalculatedTopicColor = (projectTitle: string): string => {
    if (!projectTitle) {
        return '#000';
    }

    const allColorsForTopics = [
        'var(--susy-extended-palette-aquamarine-60)',
        'var(--susy-extended-palette-aquamarine-100',
        'var(--susy-extended-palette-aquamarine-300',
        'var(--susy-extended-palette-yellow-60)',
        'var(--susy-extended-palette-yellow-100)',
        'var(--susy-extended-palette-yellow-300)',
        '#FF724F',
        '#F5542F',
        '#BE3B1E',
        'var(--susy-extended-palette-rouge-60)',
        'var(--susy-extended-palette-rouge-80',
        'var(--susy-extended-palette-rouge-300)',
        'var(--susy-extended-palette-purple-60)',
        'var(--susy-extended-palette-purple-80)',
        'var(--susy-extended-palette-purple-300)',
        '#8DB74C',
        'var(--susy-primary-color)',
        'var(--susy-primary-color-400)',
        'var(--susy-secondary-color-80)',
        'var(--susy-secondary-color-60)',
    ];

    const colorIdx = projectTitle.length % allColorsForTopics.length;

    return allColorsForTopics[colorIdx];
};

export const mapTopicToDisplayTopic = (topic: ITopic): ITopicDisplay => {
    const projectTopic = topic.project as ProjectModel;
    return {
        _id: topic._id,
        project: {
            _id: projectTopic?._id,
            title: projectTopic?.title,
        },
        title: topic.title,
        participants: topic.participants.map((participant) => ({
            firstName: participant.firstName,
            lastName: participant.lastName,
            userId: participant._id,
            profilePictureId: participant.profilePictureId,
        })),
        creationDate: topic.creationDate,
        messageFeed: topic.messageFeed,
        latestMessage: topic.latestMessage,
        isArchived: false,
    };
};

export const mapArchivedTopicToDisplayTopic = (
    archivedTopic: IArchivedTopic
): ITopicDisplay => {
    return {
        _id: archivedTopic._id,
        project: {
            _id: (archivedTopic.project as ProjectModel)._id,
            title: (archivedTopic.project as ProjectModel).title,
        },
        title: archivedTopic.title,
        participants: archivedTopic.participants.map((participant) => ({
            firstName: participant.firstName,
            lastName: participant.lastName,
            userId: participant.userId,
        })),
        creationDate: archivedTopic.creationDate,
        messageFeed: archivedTopic.messageFeed,
        latestMessage: archivedTopic.latestMessage,
        isArchived: true,
    };
};

const TopicSidebarUtils = {
    getProposedByParticipant,
    getFirstSupervisorParticipant,
    getSecondSupervisorsParticipants,
    getTeamMembersParticipants,
    getCalculatedTopicColor,
    mapTopicToDisplayTopic,
    mapArchivedTopicToDisplayTopic,
};

export default TopicSidebarUtils;
